import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/laugh': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM389.4 397.4c37.8-37.8 58.6-88 58.6-141.4s-20.8-103.6-58.6-141.4c-37.8-37.8-88-58.6-141.4-58.6s-103.6 20.8-141.4 58.6c-37.8 37.8-58.6 88-58.6 141.4s20.8 103.6 58.6 141.4c37.8 37.8 88 58.6 141.4 58.6s103.6-20.8 141.4-58.6zM328 224c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM168 224c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM362.4 288c8.2 0 14.5 7 13.5 15-7.5 59.2-58.9 105-121.1 105h-13.6c-62.2 0-113.6-45.8-121.1-105-1-8 5.3-15 13.5-15h228.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/laugh.js
// module id = 1790
// module chunks = 0